import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=f8a73d44&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=f8a73d44&prod&lang=css"
import style1 from "./sidebar.vue?vue&type=style&index=1&id=f8a73d44&prod&lang=css"
import style2 from "./sidebar.vue?vue&type=style&index=2&id=f8a73d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a73d44",
  null
  
)

export default component.exports